module.exports = __webpack_public_path__ + "static/media/car-mechanic.ea617b56.svg";